module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-mobile-en.005db99c.webp";